import { Box, FormControl, Input, Stack, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import Course from './Course/Course'
import CourseDetails from './CourseDetails/CourseDetails';
const University = () => {
    return (
        <VStack  flexDir="row" alignItems="flex-start">
            <Stack w="70%" bg="rgba(245, 245, 255, 1)" pt='80px' >
                {/* Search box */}
                <Stack flexDir="row" justifyContent="space-between" alignItems="center" w="85%" mx="auto" py="20px" px="15px">
                    <Box justifyContent="space-between" alignItems="center">
                        <Text 
                        fontFamily= "'Roboto',sans-serif"
                        fontSize='40px'
                        fontWeight= '700'
                        textAlign='left'
                        >
                            Courses
                        </Text>
                    </Box>
                    <Box w="40%">
                            <FormControl isRequired h="49px">
                                <Input placeholder='Search course here...'
                                color="rgba(149, 151, 171, 1)"
                                fontFamily= "'Roboto',sans-serif"
                                fontSize='14px'
                                fontWeight= '400'
                                textAlign='left'
                                borderRadius="15px"
                                h="49px"
                                _placeholder={{
                                    color:"rgba(149, 151, 171, 1)",
                                    fontFamily:"'Roboto',sans-serif",
                                    fontSize:'14px',
                                    fontWeight:'400',
                                    textAlign:'left',
                                }}
                                 />
                            </FormControl>
                    </Box>
                </Stack>

                <Stack flexDir="row" justifyContent="space-between" alignItems="center" w="85%" mx="auto" py="20px">
                    <Course/>
                </Stack>                    
            </Stack>
            <Stack w="30%" bg="rgba(255, 255, 255, 1)" pt='80px'>
                <CourseDetails/>                
            </Stack>
        </VStack>
    );
};

export default University;